import './App.css';
import Header from './component/Header/Header';
import Pokedex from './component/Pokedex/Pokedex';

function App() {
  return (
    <div>
      <Header></Header>
      <Pokedex></Pokedex>
    </div>
  );
}

export default App;
